// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  EstornoDialog.tsx
//  Dialog de confirmação de estorno de pagamento ou recebimento.
// ════════════════════════════════════════════════════════════════════════════

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Loader2, RotateCcw } from 'lucide-react';

interface EstornoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tipo: 'pagar' | 'receber';
  onConfirm: () => void;
  isLoading?: boolean;
}

export function EstornoDialog({
  open,
  onOpenChange,
  tipo,
  onConfirm,
  isLoading = false,
}: EstornoDialogProps) {
  const label = tipo === 'pagar' ? 'pagamento' : 'recebimento';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <RotateCcw className="h-5 w-5 text-orange-500" />
            Confirmar Estorno de {label.charAt(0).toUpperCase() + label.slice(1)}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Tem certeza que deseja estornar este {label}? A conta voltará ao status{' '}
              <strong>Pendente</strong>.
            </p>
            <p className="text-orange-600 text-xs font-medium">
              Atenção: Após o estorno, as baixas devem ser realizadas manualmente se necessário.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-orange-600 hover:bg-orange-700"
          >
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Confirmar Estorno
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
